import React, { useState } from 'react';
import { CalendarIcon, FilterIcon } from 'lucide-react';
const TeamCharts = () => {
  // Stati per i filtri
  const [dateRange, setDateRange] = useState({
    start: '2023-10-01',
    end: '2024-02-28'
  });
  const [filters, setFilters] = useState({
    onlyWins: false,
    onlyLosses: false,
    onlyHome: false,
    onlyAway: false,
    cup: true,
    league: true
  });
  // Lista giocatori
  const [players, setPlayers] = useState([{
    id: 1,
    name: 'Jalen Brunson',
    selected: true
  }, {
    id: 2,
    name: 'Julius Randle',
    selected: true
  }, {
    id: 3,
    name: 'RJ Barrett',
    selected: true
  }, {
    id: 4,
    name: 'Mitchell Robinson',
    selected: true
  }, {
    id: 5,
    name: 'Immanuel Quickley',
    selected: true
  }, {
    id: 6,
    name: 'Josh Hart',
    selected: true
  }, {
    id: 7,
    name: 'Donte DiVincenzo',
    selected: true
  }, {
    id: 8,
    name: 'Isaiah Hartenstein',
    selected: true
  }, {
    id: 9,
    name: 'Miles McBride',
    selected: true
  }, {
    id: 10,
    name: 'Precious Achiuwa',
    selected: true
  }, {
    id: 11,
    name: 'OG Anunoby',
    selected: true
  }, {
    id: 12,
    name: 'Alec Burks',
    selected: true
  }]);
  // Opzioni di visualizzazione
  const [shotOptions, setShotOptions] = useState([{
    id: 'made',
    label: 'Made Shots',
    selected: true
  }, {
    id: 'missed',
    label: 'Missed Shots',
    selected: true
  }, {
    id: '2pt',
    label: '2PT Shots',
    selected: true
  }, {
    id: '3pt',
    label: '3PT Shots',
    selected: true
  }]);
  // Dati delle percentuali per le aree del campo
  const courtAreas = [{
    id: 'left_corner_3',
    x: 50,
    y: 290,
    percentage: 42,
    label: 'Left Corner 3'
  }, {
    id: 'right_corner_3',
    x: 350,
    y: 290,
    percentage: 38,
    label: 'Right Corner 3'
  }, {
    id: 'top_arc_3',
    x: 200,
    y: 100,
    percentage: 35,
    label: 'Top Arc 3'
  }, {
    id: 'left_wing_3',
    x: 100,
    y: 150,
    percentage: 33,
    label: 'Left Wing 3'
  }, {
    id: 'right_wing_3',
    x: 300,
    y: 150,
    percentage: 36,
    label: 'Right Wing 3'
  }, {
    id: 'paint',
    x: 200,
    y: 220,
    percentage: 62,
    label: 'Paint'
  }, {
    id: 'mid_left',
    x: 120,
    y: 200,
    percentage: 45,
    label: 'Mid-Left'
  }, {
    id: 'mid_right',
    x: 280,
    y: 200,
    percentage: 48,
    label: 'Mid-Right'
  }];
  // Funzione per determinare il colore in base alla percentuale
  const getPercentageColor = percentage => {
    if (percentage >= 50) return 'text-green-600';
    if (percentage >= 35) return 'text-yellow-500';
    return 'text-red-500';
  };
  // Funzione per gestire il cambio di stato dei checkbox dei giocatori
  const togglePlayerSelection = playerId => {
    setPlayers(players.map(player => player.id === playerId ? {
      ...player,
      selected: !player.selected
    } : player));
  };
  // Funzione per gestire il cambio di stato dei checkbox delle opzioni di tiro
  const toggleShotOption = optionId => {
    setShotOptions(shotOptions.map(option => option.id === optionId ? {
      ...option,
      selected: !option.selected
    } : option));
  };
  // Funzione per gestire il cambio di stato dei filtri
  const toggleFilter = filterName => {
    setFilters({
      ...filters,
      [filterName]: !filters[filterName]
    });
  };
  return <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-115" data-mp="3fk9ilwsgzj6i">
      {/* Filtri in cima */}
      <div className="mb-6 space-y-4" data-id="element-116" data-mp="3kj2u5jo75041">
        <div className="flex flex-wrap items-center gap-4" data-id="element-117" data-mp="3ki18kl9k0v82">
          <div className="flex items-center space-x-2 bg-gray-100 p-2 rounded" data-id="element-118" data-mp="3p9t316vtzl3h">
            <CalendarIcon className="w-4 h-4 text-gray-600" data-id="element-119" data-mp="3pc5ed1732x7k" />
            <input type="date" value={dateRange.start} onChange={e => setDateRange({
            ...dateRange,
            start: e.target.value
          })} className="bg-transparent border-none text-sm" data-id="element-120" data-mp="3u7krts16ir3g" />
            <span className="text-gray-500" data-id="element-121" data-mp="74ppcxrsu0rg">to</span>
            <input type="date" value={dateRange.end} onChange={e => setDateRange({
            ...dateRange,
            end: e.target.value
          })} className="bg-transparent border-none text-sm" data-id="element-122" data-mp="3pmlki7hmh4pz" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-123" data-mp="37inerv6ax4f">
            <FilterIcon className="w-4 h-4 text-gray-600" data-id="element-124" data-mp="393g0bxxg5zn" />
            <span className="text-sm text-gray-600" data-id="element-125" data-mp="3uev475s598jt">Game filters:</span>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-126" data-mp="36p0rqpbqlm03">
            <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-127" data-mp="36psow4kzfrsh">
              <input type="checkbox" checked={filters.onlyWins} onChange={() => toggleFilter('onlyWins')} className="rounded" data-id="element-128" data-mp="3gm5i71cm83mp" />
              <span data-id="element-129" data-mp="3bmj28k5ek9a7">Wins</span>
            </label>
            <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-130" data-mp="3bp5bqpbusyv2">
              <input type="checkbox" checked={filters.onlyLosses} onChange={() => toggleFilter('onlyLosses')} className="rounded" data-id="element-131" data-mp="vy0xicubdyrc" />
              <span data-id="element-132" data-mp="28uq61yccvglj">Losses</span>
            </label>
            <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-133" data-mp="28t57lxmx7die">
              <input type="checkbox" checked={filters.onlyHome} onChange={() => toggleFilter('onlyHome')} className="rounded" data-id="element-134" data-mp="2duum5n9cq9b8" />
              <span data-id="element-135" data-mp="24sv4csqij178">Home</span>
            </label>
            <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-136" data-mp="24to2547hugd8">
              <input type="checkbox" checked={filters.onlyAway} onChange={() => toggleFilter('onlyAway')} className="rounded" data-id="element-137" data-mp="2siz6swrysuwn" />
              <span data-id="element-138" data-mp="2wlvi02f6doqk">Away</span>
            </label>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-139" data-mp="2is4gnhbllb5x">
          <span className="text-sm text-gray-600" data-id="element-140" data-mp="2nr7bk8xv6106">Competition:</span>
          <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-141" data-mp="2npe6uz6t9qut">
            <input type="checkbox" checked={filters.league} onChange={() => toggleFilter('league')} className="rounded" data-id="element-142" data-mp="3bfgxdav2uorb" />
            <span data-id="element-143" data-mp="3q4jwzzyv94c4">League</span>
          </label>
          <label className="flex items-center space-x-1 bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-144" data-mp="3q38u02d8w0m2">
            <input type="checkbox" checked={filters.cup} onChange={() => toggleFilter('cup')} className="rounded" data-id="element-145" data-mp="3l5p3a2zd1vd8" />
            <span data-id="element-146" data-mp="3g7nm5nlhw64e">Cup</span>
          </label>
        </div>
      </div>
      {/* Layout a 3 colonne */}
      <div className="grid grid-cols-3 gap-6" data-id="element-147" data-mp="3b93xhffiog8c">
        {/* Colonna 1: Lista giocatori */}
        <div className="border rounded-lg p-4" data-id="element-148" data-mp="377902m0pimzu">
          <h3 className="font-semibold text-gray-700 mb-3" data-id="element-149" data-mp="32e60nx990jbq">Players</h3>
          <div className="space-y-2 max-h-[400px] overflow-y-auto" data-id="element-150" data-mp="2xfcpibhfp4eq">
            {players.map(player => <label key={player.id} className="flex items-center space-x-2 hover:bg-gray-50 p-1 rounded" data-id="element-151" data-mp="2sg9tfgjfm8iw">
                <input type="checkbox" checked={player.selected} onChange={() => togglePlayerSelection(player.id)} className="rounded" data-id="element-152" data-mp="2nh5hwj91bype" />
                <span className="text-sm" data-id="element-153" data-mp="2jgmrmtmsj0pb">{player.name}</span>
              </label>)}
          </div>
        </div>
        {/* Colonna 2: Campo da basket */}
        <div className="border rounded-lg p-4" data-id="element-154" data-mp="12z4ivxlwlllh">
          <h3 className="font-semibold text-gray-700 mb-3" data-id="element-155" data-mp="12xtdxugq27ss">
            Shot Distribution
          </h3>
          <div className="relative" data-id="element-156" data-mp="17zioza3y2lgv">
            <svg viewBox="0 0 400 320" className="w-full" data-id="element-157" data-mp="17wei24z3hbmi">
              {/* Contorno del campo */}
              <rect x="0" y="0" width="400" height="300" fill="none" stroke="#888" strokeWidth="2" data-id="element-158" data-mp="1cuy0vwie67an" />
              {/* Linea di metà campo */}
              <line x1="0" y1="150" x2="400" y2="150" stroke="#888" strokeWidth="1" data-id="element-159" data-mp="k9ogt5ukll2y" />
              {/* Cerchio centrale */}
              <circle cx="200" cy="150" r="30" fill="none" stroke="#888" strokeWidth="1" data-id="element-160" data-mp="p6511oynffar" />
              {/* Area del tiro da 3 punti */}
              <path d="M 30,0 A 170,170 0 0 0 370,0" fill="none" stroke="#888" strokeWidth="1" data-id="element-161" data-mp="3sogc4ne68tok" />
              {/* Canestro */}
              <circle cx="200" cy="30" r="10" fill="none" stroke="#888" strokeWidth="1" data-id="element-162" data-mp="1hdhflz4k59l" />
              {/* Area del tiro libero */}
              <circle cx="200" cy="60" r="30" fill="none" stroke="#888" strokeWidth="1" data-id="element-163" data-mp="2r0h2dpz2c0af" />
              <rect x="170" y="30" width="60" height="120" fill="none" stroke="#888" strokeWidth="1" data-id="element-164" data-mp="2m2oxzwh8elpc" />
              {/* Percentuali per ogni area */}
              {courtAreas.map(area => <g key={area.id} data-id="element-165" data-mp="2v1j0g3h8u6at">
                  <circle cx={area.x} cy={area.y} r="15" fill="rgba(0,0,0,0.05)" data-id="element-166" data-mp="2v0hgtam5wbhh" />
                  <text x={area.x} y={area.y} textAnchor="middle" dominantBaseline="middle" className={`text-xs font-bold ${getPercentageColor(area.percentage)}`} data-id="element-167" data-mp="39xrxcydnw7k2">
                    {area.percentage}%
                  </text>
                </g>)}
            </svg>
          </div>
          <div className="mt-4" data-id="element-168" data-mp="3epjk0xtp5t4x">
            <div className="flex items-center justify-between text-sm" data-id="element-169" data-mp="3eql41rsoxpys">
              <div className="flex items-center space-x-1" data-id="element-170" data-mp="3sqm4j651mvdq">
                <div className="w-3 h-3 bg-red-500 rounded-full" data-id="element-171" data-mp="3nqhkj64xfiir"></div>
                <span data-id="element-172" data-mp="3nod9m48m1j8z">&lt;35%</span>
              </div>
              <div className="flex items-center space-x-1" data-id="element-173" data-mp="b6lz85zpvk0k">
                <div className="w-3 h-3 bg-yellow-500 rounded-full" data-id="element-174" data-mp="b510e46ddeww"></div>
                <span data-id="element-175" data-mp="g56yo3759zny">35-50%</span>
              </div>
              <div className="flex items-center space-x-1" data-id="element-176" data-mp="197lwf93bbch">
                <div className="w-3 h-3 bg-green-600 rounded-full" data-id="element-177" data-mp="1b24hmww2rde"></div>
                <span data-id="element-178" data-mp="667q0kmdq40y">&gt;50%</span>
              </div>
            </div>
          </div>
        </div>
        {/* Colonna 3: Opzioni di visualizzazione */}
        <div className="border rounded-lg p-4" data-id="element-179" data-mp="3td0b7zefdjwb">
          <h3 className="font-semibold text-gray-700 mb-3" data-id="element-180" data-mp="3tdt9ebzbj12u">Shot Options</h3>
          <div className="space-y-2" data-id="element-181" data-mp="3eonc4tk1jkxl">
            {shotOptions.map(option => <label key={option.id} className="flex items-center space-x-2 hover:bg-gray-50 p-1 rounded" data-id="element-182" data-mp="3jmfe6geegnfi">
                <input type="checkbox" checked={option.selected} onChange={() => toggleShotOption(option.id)} className="rounded" data-id="element-183" data-mp="35me3yac8w3nd" />
                <span className="text-sm" data-id="element-184" data-mp="39n7t171fbohu">{option.label}</span>
              </label>)}
          </div>
          <div className="mt-6" data-id="element-185" data-mp="27d377jqeywlp">
            <h4 className="font-semibold text-sm text-gray-700 mb-2" data-id="element-186" data-mp="27g7ggviqkij8">
              Shot Details
            </h4>
            <div className="space-y-3" data-id="element-187" data-mp="1yd6cp1hcf3iq">
              <div className="flex justify-between text-sm" data-id="element-188" data-mp="1ye7vjs4loub0">
                <span className="text-gray-600" data-id="element-189" data-mp="22ei3vbfv7wt1">Total Shots:</span>
                <span className="font-medium" data-id="element-190" data-mp="22f1jumlygb4f">1,245</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-191" data-mp="2q5nhdjyc2d06">
                <span className="text-gray-600" data-id="element-192" data-mp="2v3ysdy0d6tjz">Made Shots:</span>
                <span className="font-medium" data-id="element-193" data-mp="2v5jklgz7i0eo">582 (46.7%)</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-194" data-mp="2hbsbuataukk0">
                <span className="text-gray-600" data-id="element-195" data-mp="2lcuc8uyyd2nk">2PT Made:</span>
                <span className="font-medium" data-id="element-196" data-mp="2lb9mdinl27w1">392 (52.3%)</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-197" data-mp="3913u5lt1p69f">
                <span className="text-gray-600" data-id="element-198" data-mp="3duyl9aazcnij">3PT Made:</span>
                <span className="font-medium" data-id="element-199" data-mp="12eodtru9ier5">190 (37.8%)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TeamCharts;